__turbopack_context__.v({
  "accordionSlideOverwrite": "authGuard-module-scss-module__9FmB2G__accordionSlideOverwrite",
  "fadeIn": "authGuard-module-scss-module__9FmB2G__fadeIn",
  "fadeOut": "authGuard-module-scss-module__9FmB2G__fadeOut",
  "fullPage": "authGuard-module-scss-module__9FmB2G__fullPage",
  "scaleIn": "authGuard-module-scss-module__9FmB2G__scaleIn",
  "scaleOut": "authGuard-module-scss-module__9FmB2G__scaleOut",
  "zoomIn": "authGuard-module-scss-module__9FmB2G__zoomIn",
  "zoomOut": "authGuard-module-scss-module__9FmB2G__zoomOut",
});
